<template>
  <ViewForm is-add />
</template>
<script>
import ViewForm from './components/ViewForm.vue';
export default {
  name: 'BusinessStockTransferLogicAdd',
  components: {
    ViewForm,
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},

  mounted() {},
  methods: {},
};
</script>
